module.exports = __webpack_public_path__ + "img/Barlow-Italic.13ae3818.svg";